import { MapPin, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PORTRAIT = "/madhura.jpg";

const OFFICE =
  "https://images.unsplash.com/photo-1497215728101-856f4ea42174?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMHBsYW50fGVufDB8fHx8MTc4NjIwNjAxNHww&ixlib=rb-4.1.0&q=85";

const stats = [
  ["₹6,000 Cr+", "investments executed"],
  ["1,00,000+", "investors onboard"],
  ["30+", "offices across India"],
  ["SEBI", "registered platform"],
];

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="bg-[#F4F0FF] py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <Eyebrow index="05" label="Why families trust us" />
      </Reveal>

      <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 border border-wealth/15">
        {stats.map(([num, label], i) => (
          <Reveal key={label} delay={i * 0.07} className={`${i !== 0 ? "border-l border-wealth/15" : ""} ${i > 1 ? "max-lg:border-t max-lg:border-wealth/15" : ""} ${i === 2 ? "max-lg:border-l-0" : ""}`}>
            <div data-testid={`trust-stat-${i}`} className="p-8 md:p-10">
              <p className="font-display text-4xl md:text-5xl xl:text-6xl font-light tracking-tight text-wealth">{num}</p>
              <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-wealth/50">{label}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-24 grid lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-4">
          <div className="group relative max-w-sm">
            <div className="absolute -inset-3 border border-brand/50 rounded-sm pointer-events-none" />
            <div className="relative overflow-hidden rounded-sm">
              <img
                src={PORTRAIT}
                alt="Madhura Gokhale — Wealth Partner"
                data-testid="advisor-portrait"
                className="w-full aspect-square object-contain bg-[#EAE4F8] transition-transform duration-[1.4s] ease-out group-hover:scale-105"
              />
              <div className="absolute bottom-5 left-5 flex items-center gap-2 bg-wealth-dark text-bone text-xs font-semibold uppercase tracking-[0.2em] px-4 py-2.5 rounded-sm">
                <MapPin size={14} className="text-brand-light" /> Pune, India
              </div>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-wealth">
              Meet your advisor — <span className="italic text-wealth-light">Madhura Gokhale.</span>
            </h2>
            <p className="mt-7 text-base md:text-lg leading-relaxed text-wealth/70 max-w-2xl">
              Madhura helps families and individuals achieve their financial dreams. With a
              client-first approach, she specialises in personalised investment
              planning, goal-based wealth creation and effective tax-saving
              strategies — backed by the Wealthy platform's research and
              execution engine.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {["AMFI Registered", "NISM Certified", "ARN-184789"].map((b) => (
                <span
                  key={b}
                  className="inline-flex items-center gap-2 border border-wealth/20 text-wealth/75 text-[11px] font-semibold uppercase tracking-[0.18em] px-4 py-2.5 rounded-sm"
                >
                  <BadgeCheck size={14} className="text-brand" />
                  {b}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.2} className="mt-12">
            <div className="group relative overflow-hidden rounded-sm h-56 md:h-64">
              <img
                src={OFFICE}
                alt="Wealthy partner office"
                className="w-full h-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-wealth-dark/45" />
              <p className="absolute bottom-5 left-6 font-display text-2xl md:text-3xl italic text-bone">
                "Your goals become our mandate."
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
